import Alert from '@material-ui/icons/ErrorOutline'
import { ComponentVersionsInherit, ComponentVersions_3_0, styled, Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import React from 'react'

const BannerContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 16px',
  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  background: 'rgb(249, 250, 251)',
  transition: 'opacity 0.2s ease',
})

const WarningIcon = styled(Alert)({
  color: '#6b7280',
  fontSize: '22px',
  flexShrink: 0,
})

const MessageText = styled(Typography)({
  color: '#4b5563',
})

const MessageFailedBanner: React.FC = () => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <BannerContainer>
        <WarningIcon />
        <MessageText textVariant="caption1">{translate('Message failed to send. Please retry.')}</MessageText>
      </BannerContainer>
    </ComponentVersionsInherit>
  )
}

export default MessageFailedBanner
